function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 0C16.119 0 0 16.119 0 36C0 55.881 16.119 72 36 72C55.881 72 72 55.881 72 36C72 16.119 55.881 0 36 0ZM32.25 49.554L18.75 36.597L22.938 32.292L32.172 41.103L50.487 22.449L54.75 26.676L32.25 49.554Z",
  fill: "#10B981"
});

function SvgBroadcasted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcasted);
export default __webpack_public_path__ + "static/media/broadcasted.e9269c9abfc6bc5cc2d54920b524159f.svg";
export { ForwardRef as ReactComponent };